import pageRouter from '@/pages/views/user-center-template/page-router'
export default {
  path: `userCenterTemplate`,
  name: `userCenterTemplate`,
  component:pageRouter,
  redirect: { name: `templateIndex` },
  meta: {
    title: '用户中心模板首页',
    trust: true
  },
  children: [{
      path: `index`,
      name: `templateIndex`,
      component: () => import('@/pages/views/user-center-template/index'),
      meta: {
        title: '用户中心模板',
        trust: true,
        keepAlive: true
      }
    },
    {
      path: `leftRight`,
      name: `userCenterTemplate.leftRight`,
      component: () => import('@/pages/views/user-center-template/leftRight'),
      meta: {
        title: '用户中心模板左右布局',
        trust: true,
        keepAlive: true
      }
    },
    {
      path: `topBottom`,
      name: `userCenterTemplate.topBottom`,
      component: () => import('@/pages/views/user-center-template/topBottom'),
      meta: {
        title: '用户中心模板左右布局',
        trust: true,
        keepAlive: true
      }
    },
    {
      path: `commonLayout`,
      name: `userCenterTemplate.commonLayout`,
      component: () => import('@/pages/views/user-center-template/commonLayout'),
      meta: {
        title: '用户中心模板综合布局',
        trust: true,
        keepAlive: true
      }
    }
  ]
}